import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LayoutMenuHeader } from './LayoutMenuHeader';
import { LayoutMenuSection } from './LayoutMenuSection';

export function LayoutMenu(props) {
    const { t } = useTranslation("translation", { useSuspense: false });

    const [menuOpen, setOpen] = useState(false);
    const [sections, setSections] = useState([]);
    const [valueToSearch, setValueToSearch] = useState("");

    const request = {
        method: "POST",
        cache: "no-cache",
        headers: {
            "Content-Type": "application/json"
        }
    };

    useEffect(() => {        
        fetch("/Menu/GetMenuItems", request)
            .then(d => {
                if (d.status === 401)
                    throw "Authorization Error";

                return d.json();
            })
            .then(d => setSections(d || []));
    }, []);

    function handleTransitionEnd() {
        props.setMenuOpening(false);
    }

    function updateSearch(value) {
        setValueToSearch(value);

        setSections(sections.map(d => searchValue(d, value)));
    }
    function openMenu() {
        setOpen(true);
    }
    function closeMenu() {
        setValueToSearch("");
        setOpen(false);
    }

    function searchValue(currentElement, value, parentIsVisible) {
        let result = { ...currentElement };
        
        result.visible = parentIsVisible || t(result.label).toLowerCase().indexOf(value.toLowerCase()) > -1;

        if (result.submenuItems) {
            result.submenuItems = result.submenuItems.map(d => searchValue(d, value, result.visible));

            if(!result.visible && result.submenuItems.some(d => d.visible))
                result.visible = true;
        }

        return result;
    }

    const menuSections = sections.map(s => (
        <LayoutMenuSection
            key={s.id}
            id={s.id}
            label={s.label}
            icon={s.icon}
            url={s.url}
            items={s.submenuItems}
            visible={s.visible}
            isLocal={s.isLocal}
            searchValue={valueToSearch}
            menuOpen={menuOpen}
        />
    ));

    const menuClass = menuOpen ? "wis-nav-open" : "wis-nav-closed";

    return (
        <nav className={menuClass} onTransitionEnd={handleTransitionEnd}>
            <div className="wis-nav-container">
                <LayoutMenuHeader
                    updateSearch={updateSearch}
                    openMenu={openMenu}
                    closeMenu={closeMenu}
                    menuOpen={menuOpen}
                />
                <div className="wis-menu">
                    {menuSections}
                </div>
            </div>
        </nav>
    );
}


// WEBPACK FOOTER //
// ./src/components/LayoutComponents/LayoutMenu.js